import type { FC } from 'react';

interface Props {
  className?: string;
}

const PlaygroundIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 21V9l8-4 8 4v12M8 21V12h8v9"
      />
      <circle cx="12" cy="7" r="2" strokeWidth="2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 16h4" />
    </svg>
  );
};

export default PlaygroundIcon;
